import { gql } from "@apollo/client"

export const GET_ORGANIZATIONS = gql`
  query GetOrganizations($staff_id: ID!) {
    organizationsByUid(staff_id: $staff_id) {
      organization_id
      organization_name
      enterprise_id
    }
  }
`
export const GET_ORGANIZATION_PROGRAMS = gql`
  query GetOrganizationPrograms($staff_id: ID!, $organization_id: ID!) {
    programsByOrganization(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      program_id: program_identity_id
      program_id_name
      organization_name
    }
  }
`

export const GET_PROGRAM = gql`
  query GetProgram($staff_id: ID!, $organization_id: ID!, $program_id: ID!) {
    program(
      staff_id: $staff_id
      organization_id: $organization_id
      program_identity_id: $program_id
    ) {
      program_id: program_identity_id
      program_id_name
      organization_name
    }

    organization(staff_id: $staff_id, organization_id: $organization_id) {
      organization_id
      organization_name
    }
  }
`

export const GET_USERS = gql`
  query Users($staff_id: ID!, $organization_id: ID!) {
    users: staffsByOrganization(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      staff_id
      staff_name_first
      staff_name_last
      staff_email_address
      organization_name
    }

    participants: participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
      search_type: "all_participants"
    ) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_email_account
      participant_phone_primary
      participant_membership_status
      participant_profile_image
      program_list
      demo_age
      demo_race
      demo_gender
      demo_birthdate
      demo_ethnicity
    }
  }
`

export const GET_PARTICIPANTS = gql`
  query Users($staff_id: ID!, $organization_id: ID!) {
    participants: participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
      search_type: "all_participants"
    ) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_email_account
      participant_phone_primary
      participant_membership_status
      participant_profile_image
      program_list
      demo_age
      demo_race
      demo_gender
      demo_birthdate
      demo_ethnicity
    }

    programs(staff_id: $staff_id, organization_id: $organization_id) {
      program_identity_id
      program_id_name
      program_id_status
      organization_name
    }
  }
`
